<template>
  <div class="page-container" :style="getCommonStyle()">
    <!-- 头部容器 -->
    <div class="header-container">
      <!-- 标题 -->
      <div class="title-container">
        <span class="symbol-icon"></span>
        <span class="title-text">{{ $str.getKey('收益管理/电表时段') }}</span>
      </div>
      <!-- 操作按钮 -->
      <div class="operate-container">
        <div class="left-h-box">
          <!-- 选择电表 -->
          <div class="state-container">
            <div class="state-warpper loading" v-if="formData.loadState === origin.stateMap.loading">
              <el-icon size="20" class="loading-icon">
                <Refresh class="fresh" />
              </el-icon>
              <span>{{ $str.getKey('收益管理/读取中...') }}</span>
            </div>

            <div class="state-warpper success" v-if="formData.loadState === origin.stateMap.success">
              <el-icon size="20">
                <SuccessFilled />
              </el-icon>
              <span>{{ $str.getKey('收益管理/读取成功') }}</span>
            </div>

            <div class="state-warpper error" v-if="formData.loadState === origin.stateMap.error">
              <el-icon size="20">
                <CircleCloseFilled />
              </el-icon>
              <span>{{ $str.getKey('收益管理/读取失败') }}</span>
            </div>

            <div class="state-warpper warning" v-if="formData.loadState === origin.stateMap.warning">
              <el-icon size="20">
                <WarningFilled />
              </el-icon>
              <span>{{ $str.getKey('收益管理/与配置信息不一致') }}</span>
            </div>
          </div>
          <el-select v-model="formData.meterId" :placeholder="$str.getKey('收益管理/请选择电表')" clearable>
            <el-option v-for="item in formData.meterList" :key="item.uuid" :label="item.name"
              :value="item.uuid"></el-option>
          </el-select>
        </div>
        <div class="right-h-box">
          <el-button class="meter-feature-btn meter-feature-btn--lg" type="primary" @click="getInfoForMeter"
            :disabled="formData.loadState === origin.stateMap.loading">{{ $str.getKey('收益管理/读表') }}</el-button>
          <el-button class="meter-feature-btn meter-feature-btn--lg" type="primary" @click="handleModalOpen('create')" :disabled="!hasManagerRole"
            v-track-click="trackDatas.addOptBtn">{{ $str.getKey('收益管理/新增电表时段') }}</el-button>
          <el-button class="meter-feature-btn meter-feature-btn--lg" type="primary" @click="handleModalOpen('bind')" :disabled="!hasManagerRole"
            v-track-click="trackDatas.bindRelationBtn">{{ $str.getKey('收益管理/绑定关系') }}</el-button>
          <el-button class="meter-feature-btn meter-feature-btn--lg" type="primary" @click="handleModalOpen('history')"
            :disabled="!hasManagerRole">{{ $str.getKey('收益管理/操作历史') }}</el-button>
        </div>
      </div>
    </div>

    <!-- 主体容器 -->
    <div class="main-container">
      <el-calendar ref="calendarRef" class="calendar-container" v-model="calendarData.selectedInfo.date">
        <template #header="{ date }">
          <div class="calendar-header-container">
            <!-- 左侧面板：时段信息 -->
            <div class="left-panel">
              <div class="segment-item">
                <span class="name-icon sharp" v-if="isZh">{{ $str.getKey('收益管理/尖') }}</span>
                <div v-else style="display: flex; align-items: center;">
                  <span class="name-icon sharp"></span>
                  <span>{{ $str.getKey('收益管理/尖') }}</span>
                </div>
                <div class="time-list-container" v-for="item in calendarData.currSegments.sharp" :key="item">
                  <span class="time-item">{{ item.join(' - ') }}</span>
                </div>
              </div>
              <div class="segment-item">
                <span class="name-icon peak" v-if="isZh">{{ $str.getKey('收益管理/峰') }}</span>
                <div v-else style="display: flex; align-items: center;">
                  <span class="name-icon peak"></span>
                  <span>{{ $str.getKey('收益管理/峰') }}</span>
                </div>
                <div class="time-list-container" v-for="item in calendarData.currSegments.peak" :key="item">
                  <span class="time-item">{{ item.join(' - ') }}</span>
                </div>
              </div>
              <div class="segment-item">
                <span class="name-icon flat" v-if="isZh">{{ $str.getKey('收益管理/平') }}</span>
                <div v-else style="display: flex; align-items: center;">
                  <span class="name-icon flat"></span>
                  <span>{{ $str.getKey('收益管理/平') }}</span>
                </div>
                <div class="time-list-container" v-for="item in calendarData.currSegments.flat" :key="item">
                  <span class="time-item">{{ item.join(' - ') }}</span>
                </div>
              </div>
              <div class="segment-item">
                <span class="name-icon valley" v-if='isZh'>{{ $str.getKey('收益管理/谷') }}</span>
                <div v-else style="display: flex; align-items: center;">
                  <span class="name-icon valley"></span>
                  <span>{{ $str.getKey('收益管理/谷') }}</span>
                </div>
                <div class="time-list-container" v-for="item in calendarData.currSegments.valley" :key="item">
                  <span class="time-item">{{ item.join(' - ') }}</span>
                </div>
              </div>
              <div class="segment-item">
                <span class="name-icon deepValley" v-if="isZh">{{ $str.getKey('收益管理/深') }}</span>
                <div v-else style="display: flex; align-items: center;">
                  <span class="name-icon deepValley"></span>
                  <span>{{ $str.getKey('收益管理/深') }}</span>
                </div>
                <div class="time-list-container" v-for="item in calendarData.currSegments.deepValley" :key="item">
                  <span class="time-item">{{ item.join(' - ') }}</span>
                </div>
              </div>
            </div>
            <!-- 中间面板：标题-当前日期 -->
            <div class="center-panel">
              <!-- <span>{{ date }}</span> -->
              <span>{{ dayjs(calendarData.selectedInfo.date).format('YYYY 年 MM 月 DD 日') }}</span>
            </div>
            <!-- 右侧面板：切换日期按钮组 -->
            <div class="right-panel">
              <el-button size="small" @click="switchCalendarDate('prev-year')" v-if="false">{{ $str.getKey('收益管理/上年')
              }}</el-button>
              <el-button size="small" @click="switchCalendarDate('next-year')" v-if="false">{{ $str.getKey('收益管理/下年')
              }}</el-button>
              <el-button class="meter-feature-btn meter-feature-btn--sm" type="primary" @click="switchCalendarDate('today')">{{ $str.getKey('收益管理/今天')
              }}</el-button>
              <el-button class="meter-feature-btn meter-feature-btn--sm" type="primary" @click="switchCalendarDate('prev-month')">{{
                $str.getKey('收益管理/上月') }}</el-button>
              <el-button class="meter-feature-btn meter-feature-btn--sm" type="primary" @click="switchCalendarDate('next-month')">{{
                $str.getKey('收益管理/下月') }}</el-button>
            </div>
          </div>
        </template>

        <template #date-cell="{ data }">
          <div class="date-cell-container" :class="getCellClassByDate(data)" @wheel="handleWheel">
            <div class="top-info" v-if='isZh'>
              <div class="date-type-sign">
                <div class="sign-icon" v-if="isNormalWeekEnd(data.day)">{{ $str.getKey('收益管理/休') }}</div>
                <div class="sign-icon" v-if="isHoliday(data.day)">{{ $str.getKey('收益管理/假') }}</div>
                <div class="sign-icon" v-if="isLoanToWorkDay(data.day)">{{ $str.getKey('收益管理/班') }}</div>
              </div>
              <div class="today-sign-icon" v-if="isToday(data.day)">{{ $str.getKey('收益管理/今') }}</div>
              <div class="date-text-container">
                <div :class="{ 'date-text': true, 'is-selected': data.isSelected }">{{
                  +data.day.split('-').slice(-1).join('-') }}</div>
                <div class="check-icon">
                  <el-icon v-if="data.isSelected"><Select /></el-icon>
                </div>
              </div>
              <div class="bottom-info">
                <!-- 尖峰平谷深 -->
                <div class="segment-icon sharp" v-if="isShowSegmentIcon(data.day, 'sharp')">{{ $str.getKey('收益管理/尖') }}
                </div>
                <div class="segment-icon peak" v-if="isShowSegmentIcon(data.day, 'peak')">{{ $str.getKey('收益管理/峰') }}
                </div>
                <div class="segment-icon flat" v-if="isShowSegmentIcon(data.day, 'flat')">{{ $str.getKey('收益管理/平') }}
                </div>
                <div class="segment-icon valley" v-if="isShowSegmentIcon(data.day, 'valley')">{{ $str.getKey('收益管理/谷')
                  }}
                </div>
                <div class="segment-icon deepValley" v-if="isShowSegmentIcon(data.day, 'deepValley')">{{
                  $str.getKey('收益管理/深') }}</div>
              </div>
            </div>

            <div v-else>
              <div class="date-type-sign">
                <div v-if="isNormalWeekEnd(data.day)">{{ $str.getKey('收益管理/休') }}</div>
                <div v-if="isHoliday(data.day)">{{ $str.getKey('收益管理/假') }}</div>
                <div v-if="isLoanToWorkDay(data.day)">{{ $str.getKey('收益管理/班') }}</div>
              </div>
              <div v-if="isToday(data.day)">{{ $str.getKey('收益管理/今') }}</div>
              <div class="date-text-container">
                <div :class="{ 'date-text': true, 'is-selected': data.isSelected }">{{
                  +data.day.split('-').slice(-1).join('-') }}</div>
                <div class="check-icon">
                  <el-icon v-if="data.isSelected"><Select /></el-icon>
                </div>
              </div>
              <div class="bottom-info">
              <!-- 尖峰平谷深 -->
              <div  v-if="isShowSegmentIcon(data.day, 'sharp')">{{ $str.getKey('收益管理/尖') }}
              </div>
              <div  v-if="isShowSegmentIcon(data.day, 'peak')">{{ $str.getKey('收益管理/峰') }}
              </div>
              <div v-if="isShowSegmentIcon(data.day, 'flat')">{{ $str.getKey('收益管理/平') }}
              </div>
              <div  v-if="isShowSegmentIcon(data.day, 'valley')">{{ $str.getKey('收益管理/谷') }}
              </div>
              <div  v-if="isShowSegmentIcon(data.day, 'deepValley')">{{
                $str.getKey('收益管理/深') }}</div>
            </div>
            </div>

          </div>
        </template>
      </el-calendar>

    </div>

    <!-- ======【弹窗】============================================================================================= -->
    <!-- 新增电表时段 -->
    <CreateModal v-if="modalOption.createModal.isShow" v-model:show="modalOption.createModal.isShow"
      :type="modalOption.createModal.type" @onClose="handleModalClose" />
    <!-- 绑定关系 -->
    <BindRelationModal v-if="modalOption.bindModal.isShow" v-model:show="modalOption.bindModal.isShow"
      :type="modalOption.bindModal.type" @onClose="handleModalClose" />
    <!-- 操作历史 -->
    <HistoryModal v-if="modalOption.historyModal.isShow" v-model:show="modalOption.historyModal.isShow"
      :type="modalOption.historyModal.type" @onClose="handleModalClose" />

  </div>
</template>

<script setup>
import { ref, reactive, computed, watch, nextTick, onMounted, onBeforeUnmount, inject } from "vue"
import dayjs from 'dayjs';
import { v4 as uuidv4 } from 'uuid';
import { getElecPriceSegmentColor } from '@/utils/colorHelper/index.js'
import { queryMeterList, queryIssuedInfoForMeter, queryEfficientInfoForMeter, querySpecialDaysForYear } from './api/index.js'
import { isToday, isWeekEnd, checkDateIsInDateRange } from '@/utils/timeHelper/index.js';
import { cloneDeep, isEqual } from '@/utils';
import CreateModal from './createModal/index.vue';
import BindRelationModal from './bindRelationModal/index.vue';
import HistoryModal from './historyModal/index.vue';
import { useAppStore } from "@/store/modules/app";
import { checkPermi } from '@/utils/permission';

const $str = window.$str;
const isZh = computed(() => localStorage.getItem('language') == 'cn')
const hasManagerRole = computed(() => checkPermi(['operate:remoteMeter:adminRole']));
const trackEvent = inject('trackEvent');
const trackEventTypes = inject('trackEventTypes');
const trackDatas = reactive({
  readMeterBtn: {
    targetId: '',
    refData: {
      targetName: $str.getKey('收益管理/电表设置/读表按钮'),
      desc: $str.getKey('收益管理/读取电表一年的时段信息')
    },
  },
  addOptBtn: {
    targetId: '',
    refData: {
      targetName: $str.getKey('收益管理/电表设置/新增电表时段按钮'),
      desc: $str.getKey('收益管理/点击按钮，打开新增电表时段弹窗')
    },
  },
  bindRelationBtn: {
    targetId: '',
    refData: {
      targetName: $str.getKey('收益管理/电表设置/绑定关系按钮'),
      desc: $str.getKey('收益管理/点击按钮，打开绑定关系弹窗')
    },
  },
  operateHistoryBtn: {
    targetId: '',
    refData: {
      targetName: $str.getKey('收益管理/电表设置/操作历史按钮'),
      desc: $str.getKey('收益管理/点击按钮，打开操作历史面板')
    },
  },
})


dayjs.en.weekStart = 1; // 设置一周的开始日期为【周一】
const calendarRef = ref(null); // 引用calendar元素

const { stationId } = useAppStore().useStationState({
  async stationIdWatch() {
    // 监听stationId变化，获取当前电站下的电表选项
    getMeterList();
  }
});


/** 参考：原始数据 */
const origin = {
  segments: {
    sharp: [], // 尖
    peak: [], // 峰
    flat: [], // 平
    valley: [], // 谷
    deepValley: [], // 深
  },
  stateMap: {
    loading: '读取电表正在使用的时段信息',
    success: '读取成功，且与下发的配置信息一致',
    error: '读取失败',
    warning: '读取成功，但与下发的配置信息不一致',
  }

}

const formData = reactive({
  year: dayjs().format('YYYY'),
  holidayList: [],
  loanedList: [],
  meterId: '',
  meterList: [],
  loadState: origin.stateMap.error,
  apiLock: '', // API锁：用于控制-查询条件变化-发起了新的API请求后-终止&抛弃之前API请求返回的无效结果
})

const calendarData = reactive({
  dayDataPool: {},
  selectedInfo: {
    date: new Date(), // 使用dayjs创建日期，控制台VUE3会报警告-日期格式不匹配
  },
  currSegments: cloneDeep(origin.segments),
});


// 用于和弹窗交互的配置对象
const modalOption = reactive({
  createModal: {
    type: 'create',
    isShow: false,
  },
  bindModal: {
    type: 'bind',
    isShow: false,
  },
  historyModal: {
    type: 'history',
    isShow: false,
  }
})


initPage();


/** 监听选中日期的变化： */
watch(() => calendarData.selectedInfo.date, nv => {
  const date = dayjs(nv).format('YYYY-MM-DD');
  handleSelectedDateChange(date);
}, { immediate: true });


/** 监听选中电表的变化：更新日历渲染 */
watch(() => formData.meterId, nv => {
  getInfoForMeter(); // 获取电表数据 >>> 更新日历渲染
})

onBeforeUnmount(() => {
  formData.apiLock = '';
})

/** ====== [业务：功能方法] =================================================================== */

function initPage() {
  formData.year = dayjs(calendarData.selectedInfo.date).format('YYYY');
  refreshHolidayList();
}


/** 获取通用样式：设置给当前组件的顶层DOM */
function getCommonStyle() {
  const segmentColors = getElecPriceSegmentColor();
  return {
    '--sharp-color': segmentColors.sharp,
    '--peak-color': segmentColors.peak,
    '--flat-color': segmentColors.flat,
    '--valley-color': segmentColors.valley,
    '--deepValley-color': segmentColors.deepValley,
  }
}


/** 切换日历日期 */
function switchCalendarDate(date, needAlert = true) {
  if (!calendarRef.value) return;

  // 禁止切换到下一年
  if (date === 'prev-month') {
    const currDate = dayjs(calendarData.selectedInfo.date);
    const isFirstMonth = dayjs().startOf('year').isSame(currDate, 'month');
    if (isFirstMonth) {
      needAlert && window.dispatchNotify({
        type: "warning",
        message: $str.getKey('收益管理/已经是第一个月了！')
      });
      return false;
    }
  }

  // 禁止切换到上一年
  if (date === 'next-month') {
    const currDate = dayjs(calendarData.selectedInfo.date);
    const isLastMonth = dayjs().endOf('year').isSame(currDate, 'month');
    if (isLastMonth) {
      needAlert && window.dispatchNotify({
        type: "warning",
        message: $str.getKey('收益管理/已经是最后一个月了！')
      });
      return false;
    }
  }

  calendarRef.value.selectDate(date);
}


/** CellClass：基于当前日期，判断需要给cell添加哪些class */
function getCellClassByDate(data) {
  const classObj = {};

  // 判断当前日期是否被选中
  if (data.isSelected) {
    classObj['is-selected'] = true;
  }

  // 判断是否是今天
  if (isToday(data.day)) {
    classObj['is-today'] = true;
  }

  // 判断是否是周末
  if (isWeekEnd(data.day)) {
    classObj['is-weekend'] = true;
  }

  // 判断是否是常规周末
  if (isNormalWeekEnd(data.day)) {
    classObj['is-normal-weekend'] = true;
  }

  // 判断是否是节假日
  if (isHoliday(data.day)) {
    classObj['is-holiday'] = true;
  }

  // 判断是否是调班日
  if (isLoanToWorkDay(data.day)) {
    classObj['is-loan-workday'] = true;
  }

  return classObj;
}


/** 事件响应：选中的日期发生变化 */
function handleSelectedDateChange(date) {
  // 刷新：选中日-日历顶部-时段详情的渲染
  const dateStr = dayjs(date).format('YYYY-MM-DD');
  const dateInfo = calendarData.dayDataPool[dateStr];
  calendarData.currSegments = Object.assign(cloneDeep(origin.segments), dateInfo);

  // 刷新：判断year是否变化-变化-获取并更新日历信息的渲染
  const isYearChange = !dayjs(date).isSame(dayjs(formData.year), 'year');
  if (isYearChange) {
    formData.year = dayjs(date).format('YYYY');
    getInfoForMeter(); // 获取电表时段信息
    refreshHolidayList(); // 获取法定节假日信息
  }
}


/** 事件响应：鼠标滚轮切换月份 */
function handleWheel(event) {
  if (event.deltaY > 0) {
    // 下一月
    switchCalendarDate('next-month', false)
  }
  if (event.deltaY < 0) {
    // 上一月
    switchCalendarDate('prev-month', false)
  }
}



/** 刷新：日历视图 */
function refreshCalendarView() {
  handleSelectedDateChange(calendarData.selectedInfo.date)
}


/** ====== [弹窗：功能方法] =================================================================== */

function handleModalOpen(type) {
  if (type === 'create') {
    modalOption.createModal.isShow = true;
  }
  if (type === 'bind') {
    modalOption.bindModal.isShow = true;
  }
  if (type === 'history') {
    modalOption.historyModal.isShow = true;
    // 任何埋点异常都不能影响弹窗打开
    try {
      trackEvent?.(trackEventTypes?.otherOperate, trackDatas.operateHistoryBtn);
    } catch (err) {
      console.warn('[meterSetting] history track error:', err);
    }
  }

}


/** 处理弹窗的关闭事件 */
function handleModalClose(type, needRefresh = false) {
  if (type === 'create') {
    modalOption.createModal.isShow = false;
  }
  if (type === 'bind') {
    modalOption.bindModal.isShow = false;
  }
  if (type === 'history') {
    modalOption.historyModal.isShow = false;
  }



  // 关闭弹窗后，是否需要刷新页面数据
  if (needRefresh) {
    /** 添加延迟的原因：
     *  eLink在【设置数据】【读取数据】同时进行时，eLink程序存在异常
     *  >>> 设置后，延时读取。
     *  >>> 注意：延时不可靠。最佳办法，elink人员排查异常原因并进行elink异常处理。
    */
    setTimeout(() => {
      getInfoForMeter(); // 获取电表数据 >>> 更新日历渲染
    }, 4000);
  }
}






/** ====== [辅助：功能方法] =================================================================== */

/** 获取：电表列表的下拉选项 */
function getMeterList() {
  const params = {
    stationId: stationId.value,
    meterType: 3, // 1-关口电表， 3-并网点电表
  }

  queryMeterList(params).then(res => {
    if (Array.isArray(res?.rows)) {
      formData.meterList = res.rows.map(it => {
        return {
          name: it.meterName,
          uuid: it.uuid,
          devId: it.devId,
          productModel: it.productModel,
          meterType: it.meterType,
        }
      })
      if (formData.meterList.length > 0) {
        formData.meterId = formData.meterList[0].uuid;
      }
    } else {
      formData.meterList = [];
    }
  })
}



/** 获取：电表数据 */
async function getInfoForMeter() {
  // ------ 清空日历上-旧的时段信息 ------
  calendarData.dayDataPool = {};
  calendarData.currSegments = cloneDeep(origin.segments);

  // ------ 设置API锁-查询条件改变后-防止旧条件查询结果污染日历数据 ------
  const apiLock = uuidv4();
  formData.apiLock = apiLock; // 设置API锁

  // ------ 更新查询状态-读取日历上需要渲染的电表数据 ------
  refreshLoadState(origin.stateMap.loading, apiLock); // 更新状态：【正在读取中】
  let signCode = '';

  await getEfficientInfoForMeter().then(res => {
    if (res?.data && apiLock === formData.apiLock) {
      signCode = res.data;
    }
  }).catch(err => {
    console.error('读取下发给电表的时段信息，异常', err);
  }).finally(() => {
    // 埋点信息：
    trackDatas.readMeterBtn.refData['stationId'] = stationId.value;
    trackDatas.readMeterBtn.refData['meterUuid'] = formData.meterId;
    trackDatas.readMeterBtn.refData['year'] = dayjs(formData.year).format('YYYY');
    trackEvent(trackEventTypes.otherOperate, trackDatas.readMeterBtn);
  });
  // 异常or没有获取到signCode，返回，并提示用户：如，稍后重试
  if (!signCode) {
    refreshLoadState(origin.stateMap.error, apiLock); // 更新状态：【读取失败】
    return false;
  }

  await getIssuedInfoForMeter(signCode, apiLock).then(res => {
    if (res?.data) {
      if (Array.isArray(res?.data?.remote?.calendarData)) {
        const ruleList = res.data.remote.ruleList ?? [];

        // 根据规则类型，获取时段信息
        const getSegmentsInfo = (ruleType) => {
          const rule = ruleList.find(it => it.type === ruleType);
          if (rule) {
            const segments = cloneDeep(origin.segments);
            segments.sharp = rule.ruleInfo.sharp ?? [];
            segments.peak = rule.ruleInfo.peak ?? [];
            segments.flat = rule.ruleInfo.flat ?? [];
            segments.valley = rule.ruleInfo.valley ?? [];
            segments.deepValley = rule.ruleInfo.deepValley ?? [];
            return segments;
          } else {
            const segments = cloneDeep(origin.segments);
            return segments;
          }
        }

        // 从响应数据中，提取日历中要渲染的时段信息
        const dayDataPool = {};
        res.data.remote.calendarData.forEach(it => {
          const isSelectYear = dayjs(it.date).isSame(dayjs(formData.year), 'year');
          if (isSelectYear) {
            const key = dayjs(it.date).format('YYYY-MM-DD');
            dayDataPool[key] = getSegmentsInfo(it.ruleType);
          }
        })
        calendarData.dayDataPool = dayDataPool;

        // 判断一致性：
        const geminiInfo = res.data.local;
        const eLinkInfo = res.data.remote;
        const isSame = isEqual(geminiInfo.ruleList, eLinkInfo.ruleList) && isEqual(geminiInfo.calendarData, eLinkInfo.calendarData);
        if (isSame) {
          refreshLoadState(origin.stateMap.success, apiLock); // 更新状态：【读取成功】
        } else {
          refreshLoadState(origin.stateMap.warning, apiLock); // 更新状态：【读取成功-但实际配置和下发的配置不一致】
        }
      }

    } else {
      refreshLoadState(origin.stateMap.error, apiLock); // 更新状态：【读取失败】
    }
  }).catch(err => {
    console.error('读取下发给电表的时段信息，异常', err);
    calendarData.dayDataPool = {};
    refreshLoadState(origin.stateMap.error, apiLock); // 更新状态：【读取失败】
  }).finally(() => {
    refreshCalendarView();
  });

}


/** 获取：下发给电表的时段信息 */
function getEfficientInfoForMeter() {
  const params = {
    year: dayjs(formData.year).format('YYYY'),
  }

  if (formData.meterId) {
    const meter = formData.meterList.find(it => it.uuid === formData.meterId);
    if (meter) {
      params.uuid = meter.uuid;
      params.devId = meter.devId;
      params.productModel = meter.productModel;
    }
  }
  if (!params.uuid) {
    window.dispatchNotify({
      type: "warning",
      message: $str.getKey('收益管理/请选择电表！')
    });
    return Promise.resolve(false);
  }

  return queryEfficientInfoForMeter(params);
}



/** 获取：下发给电表的时段信息 */
async function getIssuedInfoForMeter(signCode, apiLock, maxTryCount = 5, currTryCount = 0) {
  if (apiLock !== formData.apiLock) { return false; }
  if (!formData.meterId) { return false; }
  if (!signCode) { return false; }

  let resData = await queryIssuedInfoForMeter(formData.meterId).then(res => {

    // if (res?.data?.remote?.traceingNo && formData.meterId === '06-V21-1') { res.data.remote.traceingNo = signCode } // dev---:mock
    // res.data.remote.ruleList = []; // dev---:mock

    if (res?.data?.remote?.traceingNo === signCode) {
      return res;
    }
  }).catch(err => {
    // console.error('读取下发给电表的时段信息，异常',err);
  }).finally(() => { })

  if (resData) {
    return resData;
  } else if (currTryCount < maxTryCount) {
    await new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve();
      }, 3000);
    })
    return await getIssuedInfoForMeter(signCode, apiLock, maxTryCount, currTryCount + 1);
  } else {
    return false;
  }

}



/** 获取：year对应的法定节假日 */
function refreshHolidayList(year = formData.year) {
  querySpecialDaysForYear(year, [3, 4]).then(res => {
    if (Array.isArray(res.data)) {
      const holidayList = []
      const loanedList = []

      res.data.forEach(it => {
        let date = dayjs(it.startDate);
        const range = [it.startDate, it.endDate];
        while (checkDateIsInDateRange(date, range)) {
          if (it.type === 3) {
            holidayList.push(date.format('YYYY-MM-DD'));
          }
          if (it.type === 4) {
            loanedList.push(date.format('YYYY-MM-DD'));
          }
          date = date.add(1, 'day');
        }
      })

      formData.holidayList = holidayList;
      formData.loanedList = loanedList;
    }
  })
}


/**更新：读取状态 */
function refreshLoadState(state, apiLock) {
  if (apiLock === formData.apiLock) {
    formData.loadState = state; // 更新状态
  }
}


/** 判断：是否展示date对应iconType的图标 */
function isShowSegmentIcon(date, iconType) {
  const dateStr = dayjs(date).format('YYYY-MM-DD');
  const dateInfo = calendarData.dayDataPool[dateStr];
  if (dateInfo && Array.isArray(dateInfo[iconType]) && dateInfo[iconType].length > 0) {
    return true;
  } else {
    return false;
  }
}


/** 判断：是否为正常的周末休息日 */
function isNormalWeekEnd(date) {
  let isNormal = isWeekEnd(date);
  // 是否为调班日
  if (isNormal && isLoanToWorkDay(date)) {
    isNormal = false;
  }
  // 是否为休假日
  if (isNormal && isHoliday(date)) {
    isNormal = false;
  }
  return isNormal;
}


/** 判断：日期是否是节假日 */
function isHoliday(date) {
  const dateStr = dayjs(date).format('YYYY-MM-DD');
  return formData.holidayList.includes(dateStr);
}


/** 判断：日期是否是调班日 */
function isLoanToWorkDay(date) {
  const dateStr = dayjs(date).format('YYYY-MM-DD');
  return formData.loanedList.includes(dateStr);
}


</script>
<style lang="scss" scoped>
@import './button-style.scss';

.page-container {
  --page-top: 8px;
  --header-hight: 46px;
  /* 主题变量兜底：兼容当前系统（避免移植后变量缺失导致颜色/对比异常） */
  --ms-level0-bg-color: var(--level0-bg-color, rgba(46, 46, 46, 0.08));
  --ms-level1-bg-color: var(--level1-bg-color, #ffffff);
  --ms-level2-bg-color: var(--level2-bg-color, #f6f7fb);
  --ms-hover-bg-color: var(--hover-bg-color, rgba(46, 46, 46, 0.04));
  --ms-active-bg-color: var(--active-bg-color, rgba(58, 104, 255, 0.12));
  // 设置cell相关的变量
  --normal-cell-bg-color: rgba(255, 255, 255, 0.86);
  --selected-cell-bg-color: var(--ms-active-bg-color);
  --hover-cell-bg-color: rgba(58, 104, 255, 0.06);
  --today-cell-bg-color: rgba(255, 255, 255, 0.96);
  --cell-border-color: rgba(0, 0, 0, 0.08);
  --cell-shadow: 0 1px 2px rgba(16, 24, 40, 0.08);
  --holiday-cell-bg-color: #64ee0eCC;
  --weekend-bg-color: #EDD1AB;
  // --weekend-cell-bg-color-normal: #c6edabcc;
  --weekend-cell-bg-color-normal: var(--normal-cell-bg-color);
  --sign-icon-color: #D9001B;

  & {
    width: 100%;
    height: calc(100% - var(--page-top));
    min-height: 0;
    max-width: 100%;
    min-width: 0;
    position: relative;
    isolation: isolate;
    /* 远程电表页保持一屏展示，避免外层滚动条干扰滚轮切月 */
    overflow-x: hidden;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    background: rgba(255, 255, 255, 0.5);
    backdrop-filter: blur(10px);
    margin-top: var(--page-top);
    padding: 8px;

    border-radius: 20px;
    border: 1px solid rgba(0, 0, 0, 0.06);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);

    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .header-container {
    width: 100%;
    min-height: var(--header-hight);
    height: auto;
    position: relative;
    z-index: 20;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    flex-wrap: wrap;
    flex-shrink: 0;

    .title-container {
      flex: 0 1 auto;
      max-width: 100%;
      min-width: 0;
      height: 100%;
      padding-left: 6px;
      display: flex;
      align-items: center;
      gap: 10px;

      .symbol-icon {
        width: 4px;
        height: 20px;
        background: #485e91;
      }

      .title-text {
        font-size: 18px;
      }
    }

    .operate-container {
      & {
        width: 100%;
        height: 100%;
        flex: 1;
        position: relative;
        z-index: 21;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 14px;
        flex-wrap: wrap;
        min-width: 0;
      }

      .left-h-box {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-wrap: wrap;
        min-width: 0;

        .state-container {
          display: flex;
          align-items: center;

          .state-warpper {
            & {
              min-width: 86px;
              min-height: 40px;
              padding: 0 12px;
              margin: 0;
              border-radius: 20px;
              color: rgba(47, 107, 255, 0.92);
              background: #fff;
              border: 1px solid rgba(192, 207, 218, 0.3);
              box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
              display: inline-flex;
              gap: 4px;
              justify-content: center;
              align-items: center;
              font-size: 13px;
              line-height: 40px;
              white-space: nowrap;
              box-sizing: border-box;
            }

            &.loading {
              color: rgba(21, 128, 61, 0.92);
              background: #fff;

              .fresh {
                background-color: rgba(21, 128, 61, 0.2);
                border-radius: 50%;
                color: rgba(21, 128, 61, 0.92);
                transform: rotateX(180deg);
              }

              .loading-icon {
                animation: loading-rotate 2s infinite linear;
              }

              @keyframes loading-rotate {
                from {
                  transform: rotate(0);
                }

                to {
                  transform: rotate(360deg);
                }
              }
            }

            &.error {
              color: rgba(220, 38, 38, 0.92);
              background: #fff;
            }

            &.success {
              color: rgba(5, 150, 105, 0.92);
              background: #fff;
            }

            &.warning {
              color: rgba(234, 88, 12, 0.92);
              background: #fff;
            }
          }
        }

        :deep(.el-select) {
          width: 240px;
          max-width: 100%;
        }
      }

      .right-h-box {
        display: flex;
        align-items: center;
        gap: 10px;
        position: relative;
        z-index: 22;
        flex-wrap: wrap;
        justify-content: flex-end;
      }

      /* 对齐「电表读数」页控件（MeterData.vue） */
      :deep(.el-input__wrapper),
      :deep(.el-select__wrapper),
      :deep(.el-date-editor .el-input__wrapper) {
        background: #fff;
        border: 1px solid rgba(192, 207, 218, 0.3);
        border-radius: 20px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
        padding: 0 16px;
        min-height: 40px;
        height: 40px;
        align-items: center;
        transition: border-color 0.2s;
      }

      :deep(.el-input__wrapper.is-focus),
      :deep(.el-select__wrapper.is-focused),
      :deep(.el-date-editor .el-input__wrapper.is-focus) {
        border-color: #3a68ff;
      }

      /* 按钮：图2 胶囊主按钮（蓝底白字） */
      :deep(.el-button) {
        height: 40px;
        min-height: 40px;
        border-radius: 999px;
        font-size: 14px;
        padding: 0 18px;
        box-shadow: none;
      }

      :deep(.el-button--primary) {
        background: #3a68ff;
        border-color: #3a68ff;
        --el-button-text-color: #fff;
      }

      /* 按钮统一白字（本页 UI 规范） */
      :deep(.el-button:not(.is-link)) {
        --el-button-text-color: #fff;
        color: #fff;
      }

      /* plain/默认按钮也保持可读性（白字 + 蓝底） */
      :deep(.el-button.is-plain:not(.is-link)),
      :deep(.el-button:not(.el-button--primary):not(.is-link)) {
        background: #3a68ff;
        border-color: #3a68ff;
      }

      :deep(.el-button.is-plain:not(.is-link):hover),
      :deep(.el-button:not(.el-button--primary):not(.is-link):hover) {
        opacity: 0.9;
      }

      :deep(.el-button--primary:hover) {
        background: #3a68ff;
        border-color: #3a68ff;
        opacity: 0.9;
      }

      :deep(.el-button--primary:active) {
        opacity: 0.8;
      }
    }

  }

  .main-container {
    & {
      width: 100%;
      height: 100%;
      flex: 1;
      min-height: 0;
      position: relative;
      z-index: 1;
      overflow-x: hidden;
      overflow-y: hidden;
      -webkit-overflow-scrolling: touch;
    }

    ::v-deep .calendar-container {
      width: 100%;
      height: 100%;
      min-height: 0;
      background-color: var(--ms-level1-bg-color);
      display: flex;
      flex-direction: column;

      /* 吃掉 Element Plus 默认留白，把空间还给日期表格 */
      .el-calendar__header {
        padding: 0 0 8px;
      }

      .el-calendar__body {
        padding: 0;
        min-height: 0;
        box-sizing: border-box;
      }

      /** 设置日历头部的信息面板 */
      .calendar-header-container {
        width: 100%;
        min-width: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 12px;
        font-size: 13px;
        flex-wrap: wrap;

        .left-panel {
          flex: 1 1 260px;
          min-width: 0;
          display: flex;
          flex-direction: column;
          gap: 4px;

          .segment-item {
            font-size: 12px;
            display: flex;
            align-items: center;
            gap: 6px;

            .name-icon {
              & {
                width: 22px;
                height: 22px;
                border: 1px solid currentColor;
                border-radius: 50%;
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: color-mix(in srgb, currentColor 30%, #FFFFFF);
              }

              &.sharp {
                color: var(--sharp-color);
              }

              &.peak {
                color: var(--peak-color);
              }

              &.flat {
                color: var(--flat-color);
              }

              &.valley {
                color: var(--valley-color);
              }

              &.deepValley {
                color: var(--deepValley-color);
              }
            }
          }

        }

        .center-panel {
          min-width: 150px;
          flex: 0 1 auto;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;
        }


        .right-panel {
          flex: 1 1 260px;
          min-width: 0;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          flex-wrap: wrap;
          gap: 8px;

          :deep(.el-button) {
            height: 36px;
            min-height: 36px;
            padding: 0 16px;
            border-radius: 999px;
            font-size: 13px;
          }
        }
      }

      /** 设置日历Body面板的样式 */
      .el-calendar__body {
        
        & {
          flex: 1;
          height: 100%;
          min-height: 0;
        }

        .el-calendar-table {
          height: 100%;

          .el-calendar-table__row {

            td {

              // &.prev &.current &.next
              & {
                padding: 4px;
              }

              &.prev,
              &.next {
                opacity: 0.4;
                pointer-events: none;
                /* 禁止鼠标事件 */
              }

              .el-calendar-day {
                height: 100%;
                padding: 0;
                background-color: var(--normal-cell-bg-color);
                border-radius: 4px;
                box-shadow: var(--cell-shadow);
                border: 1px solid var(--cell-border-color);
              }

              &.is-today .el-calendar-day {
                background-color: var(--today-cell-bg-color);
              }

              &.is-selected .el-calendar-day {
                background-color: var(--selected-cell-bg-color);
              }
            }
          }
        }
      }

      /** 设置日历自定义Cell的样式 */
      .date-cell-container {
        & {
          height: 100%;
          padding: 6px 8px;
          margin: 0;
          border-radius: 4px;
          box-shadow: var(--cell-shadow);
          border: 1px solid var(--cell-border-color);
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }

        /*------[处理特殊日期的样式]------------------------------*/
        &.is-weekend,
        &.is-normal-weekend,
        &.is-holiday {
          &.is-today {
            background-color: var(--today-cell-bg-color);
          }

          &.is-selected {
            background-color: var(--selected-cell-bg-color);
          }

          &:hover {
            background: var(--hover-cell-bg-color);
          }
        }

        // 常规周末的样式
        &.is-normal-weekend {
          background-color: var(--weekend-cell-bg-color-normal);
        }

        // 节假日的样式
        &.is-holiday {
          background-color: var(--holiday-cell-bg-color);
        }

        .top-info {
          display: flex;
          justify-content: space-between;

          .date-type-sign {
            .sign-icon {
              width: 28px;
              height: 28px;
              font-size: 16px;
              color: var(--sign-icon-color);
              border: 1px solid currentColor;
              border-radius: 50%;
              background-color: color-mix(in srgb, currentColor 10%, #FFFFFF88);
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }

          .today-sign-icon {
            width: 28px;
            height: 28px;
            color: var(--sign-icon-color);
            font-size: 16px;
            border: 1px solid currentColor;
            border-radius: 50%;
            background-color: color-mix(in srgb, currentColor 10%, #FFFFFF88);
            // background-color: color-mix(in srgb, lime 30%, #FFFFFF88);
          }

          .date-text-container {
            width: 28px;
            height: 28px;
            font-size: 20px;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 2px;

            .date-text {
              &.is-selected {
                color: lime;
              }
            }

            .check-icon {
              color: lime;
              margin-top: -8px;
            }
          }
        }

        .bottom-info {
          width: 100%;
          height: 26px;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 4px;

          .segment-icon {
            & {
              width: 26px;
              height: 26px;
              border: 1px solid currentColor;
              border-radius: 50%;
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: color-mix(in srgb, currentColor 10%, #FFFFFFdd);
            }

            &.sharp {
              color: var(--sharp-color);
            }

            &.peak {
              color: var(--peak-color);
            }

            &.flat {
              color: var(--flat-color);
            }

            &.valley {
              color: var(--valley-color);
            }

            &.deepValley {
              color: var(--deepValley-color);
            }
          }


        }
      }
    }
  }


}
</style>
